import { LucideIcon } from 'lucide-react';

interface IconBoxProps {
  icon: LucideIcon;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const IconBox = ({ 
  icon: Icon, 
  size = 'md', 
  className = '' 
}: IconBoxProps) => {
  const sizes = {
    sm: 'w-10 h-10',
    md: 'w-12 h-12',
    lg: 'w-14 h-14'
  };

  return (
    <div className={`
      bg-blue-100 rounded-lg flex items-center justify-center
      ${sizes[size]} ${className}
    `}>
      <Icon className="w-1/2 h-1/2 text-blue-600" />
    </div>
  );
};

export default IconBox;